import script from "./RequestSupportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestSupportForm.vue?vue&type=script&setup=true&lang=js"

import "./RequestSupportForm.vue?vue&type=style&index=0&id=52944345&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52944345"]])

export default __exports__